var _path, _g, _path2, _path3, _path4, _path5, _g2, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadsEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 150,
    viewBox: "0 0 171 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.4985 143.51C130.049 143.51 162.112 111.446 162.112 71.755C162.112 32.0637 130.049 0 90.4985 0C50.9485 0 18.8848 32.0637 18.8848 71.755C18.8848 111.446 50.9485 143.51 90.4985 143.51Z",
    fill: "#F0F2F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13969_5404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.891 43.0819H34.4275C31.7437 43.0819 29.625 40.9631 29.625 38.2794V10.7356C29.625 8.05186 31.7437 5.93311 34.4275 5.93311H156.75C159.434 5.93311 161.553 8.05186 161.553 10.7356V38.2794C161.694 40.9631 159.434 43.0819 156.891 43.0819Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5566 23.1973C50.0064 23.1973 51.1816 22.022 51.1816 20.5723C51.1816 19.1225 50.0064 17.9473 48.5566 17.9473C47.1069 17.9473 45.9316 19.1225 45.9316 20.5723C45.9316 22.022 47.1069 23.1973 48.5566 23.1973Z",
    fill: "#50CCA6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9533 31.0723C44.7124 31.0739 44.474 31.0234 44.2544 30.9244C44.0348 30.8254 43.8392 30.6801 43.6809 30.4985C43.5369 30.3328 43.4304 30.138 43.3685 29.9274C43.3066 29.7168 43.2909 29.4953 43.3225 29.2781C43.5381 28.0522 44.1831 26.9431 45.1421 26.1496C46.101 25.356 47.3112 24.9298 48.5558 24.9473C49.8004 24.9298 51.0106 25.356 51.9696 26.1496C52.9285 26.9432 53.5735 28.0524 53.7891 29.2783C53.8206 29.4955 53.8049 29.7169 53.7431 29.9275C53.6812 30.1381 53.5746 30.3329 53.4307 30.4985C53.2724 30.6801 53.0768 30.8254 52.8572 30.9244C52.6376 31.0234 52.3992 31.0739 52.1583 31.0723H44.9533Z",
    fill: "#50CCA6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0371 21.3288H66.9171C66.2109 21.3288 65.7871 20.7638 65.7871 20.1988V16.6676C65.7871 15.9613 66.3521 15.5376 66.9171 15.5376H94.0371C94.7434 15.5376 95.1671 16.1026 95.1671 16.6676V20.1988C95.1671 20.9051 94.7434 21.3288 94.0371 21.3288Z",
    fill: "#E4E7EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.242 33.3352H66.9171C66.2109 33.3352 65.7871 32.7702 65.7871 32.2052V28.6739C65.7871 27.9677 66.3521 27.5439 66.9171 27.5439H126.242C126.948 27.5439 127.372 28.1089 127.372 28.6739V32.2052C127.372 32.9114 126.807 33.3352 126.242 33.3352Z",
    fill: "#E4E7EC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13969_5404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.891 135.741H34.4275C31.7437 135.741 29.625 133.622 29.625 130.939V103.395C29.625 100.711 31.7437 98.5923 34.4275 98.5923H156.75C159.434 98.5923 161.553 100.711 161.553 103.395V130.939C161.694 133.622 159.434 135.741 156.891 135.741Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13969_5404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6914 115.783C50.1412 115.783 51.3164 114.607 51.3164 113.158C51.3164 111.708 50.1412 110.533 48.6914 110.533C47.2417 110.533 46.0664 111.708 46.0664 113.158C46.0664 114.607 47.2417 115.783 48.6914 115.783Z",
    fill: "#50CCA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.088 123.658C44.8471 123.659 44.6088 123.609 44.3892 123.51C44.1696 123.411 43.974 123.266 43.8157 123.084C43.6717 122.918 43.5651 122.723 43.5033 122.513C43.4414 122.302 43.4257 122.081 43.4572 121.864C43.6728 120.638 44.3179 119.529 45.2769 118.735C46.2358 117.941 47.446 117.515 48.6906 117.533C49.9352 117.515 51.1454 117.941 52.1043 118.735C53.0633 119.529 53.7083 120.638 53.9239 121.864C53.9554 122.081 53.9397 122.302 53.8778 122.513C53.816 122.724 53.7094 122.918 53.5654 123.084C53.4072 123.266 53.2115 123.411 52.9919 123.51C52.7724 123.609 52.534 123.659 52.2931 123.658H45.088Z",
    fill: "#50CCA6"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0371 114.131H66.9171C66.2109 114.131 65.7871 113.566 65.7871 113.001V109.469C65.7871 108.763 66.3521 108.339 66.9171 108.339H94.0371C94.7434 108.339 95.1671 108.904 95.1671 109.469V113.001C95.1671 113.566 94.7434 114.131 94.0371 114.131Z",
    fill: "#E4E7EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.242 126.136H66.9171C66.2109 126.136 65.7871 125.571 65.7871 125.006V121.475C65.7871 120.769 66.3521 120.345 66.9171 120.345H126.242C126.948 120.345 127.372 120.91 127.372 121.475V125.006C127.372 125.571 126.807 126.136 126.242 126.136Z",
    fill: "#E4E7EC"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_13969_5404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.125 89.4119H13.8025C11.1188 89.4119 9 87.2932 9 84.6094V57.0657C9 54.3819 11.1188 52.2632 13.8025 52.2632H136.125C138.809 52.2632 140.928 54.3819 140.928 57.0657V84.6094C141.069 87.2932 138.809 89.4119 136.125 89.4119Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4121 67.6584H46.2921C45.5859 67.6584 45.1621 67.0934 45.1621 66.5284V62.9972C45.1621 62.2909 45.7271 61.8672 46.2921 61.8672H73.4121C74.1184 61.8672 74.5421 62.4322 74.5421 62.9972V66.5284C74.5421 67.2347 74.1184 67.6584 73.4121 67.6584Z",
    fill: "#E4E7EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.617 79.8054H46.2921C45.5859 79.8054 45.1621 79.2404 45.1621 78.6754V75.1442C45.1621 74.4379 45.7271 74.0142 46.2921 74.0142H105.476C106.182 74.0142 106.606 74.5792 106.606 75.1442V78.6754C106.747 79.2404 106.182 79.8054 105.617 79.8054Z",
    fill: "#E4E7EC"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13969_5404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1387 69.5103C29.5884 69.5103 30.7637 68.335 30.7637 66.8853C30.7637 65.4355 29.5884 64.2603 28.1387 64.2603C26.6889 64.2603 25.5137 65.4355 25.5137 66.8853C25.5137 68.335 26.6889 69.5103 28.1387 69.5103Z",
    fill: "#50CCA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5353 77.3853C24.2944 77.3869 24.056 77.3364 23.8364 77.2374C23.6169 77.1383 23.4212 76.9931 23.2629 76.8115C23.119 76.6458 23.0124 76.451 22.9505 76.2404C22.8887 76.0298 22.873 75.8083 22.9045 75.5911C23.1201 74.3652 23.7652 73.2561 24.7241 72.4625C25.6831 71.669 26.8932 71.2428 28.1378 71.2603C29.3824 71.2428 30.5926 71.669 31.5516 72.4626C32.5105 73.2562 33.1556 74.3653 33.3712 75.5913C33.4027 75.8085 33.3869 76.0299 33.3251 76.2405C33.2632 76.4511 33.1567 76.6458 33.0127 76.8115C32.8544 76.9931 32.6588 77.1383 32.4392 77.2374C32.2196 77.3364 31.9812 77.3869 31.7404 77.3853H24.5353Z",
    fill: "#50CCA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13969_5404",
    x: 20.625,
    y: 1.93311,
    width: 149.934,
    height: 55.1489,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13969_5404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13969_5404",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13969_5404",
    x: 20.625,
    y: 94.5923,
    width: 149.934,
    height: 55.1489,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13969_5404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13969_5404",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_13969_5404",
    x: 0,
    y: 48.2632,
    width: 149.934,
    height: 55.1489,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13969_5404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13969_5404",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13969_5404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(41.6914 110.095)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13969_5404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(21.1387 63.8228)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsEmpty);
export default __webpack_public_path__ + "static/media/leads-empty.c5448487838eda8624a4860d27d91f1b.svg";
export { ForwardRef as ReactComponent };